import { InputText } from 'primereact/inputtext';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import AddProductDetail from '../add/AddProductDetail';

const Filters = ({
  setDescriptionFilter,
  setDivisionFilter,
  setProductTypeFilter,
  setShouldReload
}: IFiltersProps): JSX.Element => {
  return (
    <div className={styles.container}>
      <InputText
        className={styles.filter}
        placeholder="Description"
        onChange={e => {
          setDescriptionFilter(e.target.value);
        }}
      />

      <InputText
        className={styles.filter}
        placeholder="Division"
        onChange={e => {
          setDivisionFilter(e.target.value);
        }}
      />

      <InputText
        className={styles.filter}
        placeholder="Product type"
        onChange={e => {
          setProductTypeFilter(e.target.value);
        }}
      />

      <AddProductDetail setShouldReload={setShouldReload} />
    </div>
  );
};

export default Filters;
